export default __webpack_public_path__ + "static/media/altaguardia.53bd3f32.jpg";